import React, { Suspense } from 'react'
import { Outlet } from 'react-router'
import { Loading } from 'flipper-ui'
import { IconWifiOff } from 'flipper-ui/icons/mui'
import { useConnectivityContext } from '@core/context/ConnectivityContext'
import { AppContent } from '@core/layout/AppContent'
import { IconWrapper } from './styles'

const AppLayout = () => {
    const { isOnline } = useConnectivityContext()

    return (
        <AppContent>
            {isOnline ? (
                <Suspense fallback={<Loading />}>
                    <Outlet />
                </Suspense>
            ) : (
                <IconWrapper>
                    <IconWifiOff color='primary' fontSize='large' />
                </IconWrapper>
            )}
        </AppContent>
    )
}

export default AppLayout
